import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) {}

  login(username: string, password: string): Observable<any> {
    return this.http.post<any>(this.apiUrl + '/auth/login', { username, password }).pipe(
      tap(res => {
        if (res && res.token) {
          localStorage.setItem('authToken', res.token);
          // Store user data
          if (res.user) {
            localStorage.setItem('currentUser', JSON.stringify(res.user));
          }
        }
      })
    );
  }

  logout() { 
    localStorage.removeItem('authToken');
    localStorage.removeItem('currentUser');
  }
  
  getToken() { 
    return localStorage.getItem('authToken'); 
  }

  getCurrentUser() {
    const userStr = localStorage.getItem('currentUser');
    if (userStr) {
      try {
        return JSON.parse(userStr);
      } catch (e) {
        return null;
      }
    }
    // Fallback: return basic user object if no stored user
    return { username: 'Admin', role: 'admin' };
  }
}
